/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon20Light = forwardRef('ArrowCRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.021 3.396a.5.5 0 0 1 .708 0l4.836 4.836a2.5 2.5 0 0 1 0 3.536l-4.836 4.836a.5.5 0 1 1-.708-.707l4.836-4.836a1.5 1.5 0 0 0 0-2.122L7.021 4.104a.5.5 0 0 1 0-.708Z" })));
});
